import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const WidgetHider = () => {
  const location = useLocation();

  useEffect(() => {
    const shouldHideWidget = () => {
      const pathname = location.pathname;

      // Routes where widget should be hidden
      const hiddenRoutes = ["/agent/", "/live-agent/", "/genie/", "/studio/", "/user-hub/genie-setup", "/tour", "/clubs-onboarding", "/setup"];

      return hiddenRoutes.some((route) => pathname.startsWith(route));
    };

    const toggleWidgetVisibility = (hide: boolean) => {
      // Hide the gptengine widget if it exists
      const gptEngineWidget = document.querySelector(
        '[id*="gptengine"], [class*="gptengine"], [class*="GPT"], .gptengine, #gptengine'
      ) as HTMLElement;
      if (gptEngineWidget) {
        gptEngineWidget.style.display = hide ? "none" : "";
      }

      // Hide helpgenie widget if it exists
      const helpGenieWidget = document.getElementById("helpgenie-widget-container") as HTMLElement;
      if (helpGenieWidget) {
        helpGenieWidget.style.display = hide ? "none" : "";
      }

      // Only inspect widget-marked elements: fixed positioning and a high z-index
      // also belong to legitimate portalled menus, including full-chat settings.
      const widgetElements = document.querySelectorAll('[id*="widget"], [class*="widget"]');
      widgetElements.forEach((element) => {
        const el = element as HTMLElement;
        // Only hide if it looks like a chat widget (has high z-index and is positioned fixed)
        const styles = window.getComputedStyle(el);
        const zIndex = parseInt(styles.zIndex) || 0;
        const position = styles.position;

        if (position === "fixed" && zIndex > 1000) {
          el.style.display = hide ? "none" : "";
        }
      });
    };

    const hide = shouldHideWidget();
    toggleWidgetVisibility(hide);

    // Also check periodically in case widget loads after component mount
    const checkInterval = setInterval(() => {
      if (shouldHideWidget()) {
        toggleWidgetVisibility(true);
      }
    }, 1000);

    // Cleanup interval when component unmounts or location changes
    return () => {
      clearInterval(checkInterval);
      // Restore widget visibility when leaving hidden routes
      if (!shouldHideWidget()) {
        toggleWidgetVisibility(false);
      }
    };
  }, [location.pathname]);

  return null;
};

export default WidgetHider;
